<template>
  <div>
    <GoogleMapLoader
      :mapConfig="mapConfig"
      :apiKey="mapKey">
      <template slot-scope="{google, map}" ref="map">
        <GoogleMapMarker
          :google="google"
          :map="map"
        />
      </template>
    </GoogleMapLoader>
  </div>
</template>
<script>
import GoogleMapLoader from '../map/GoogleMapLoader'
import GoogleMapMarker from '../map/GoogleMapMarker'
import { mapSettings } from '../../../constants/mapSettings'
import config from '../../../environmentConfig.json'
export default {
  name: 'TravelMap',
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
  },
  computed: {
    mapConfig () {
      return {
        ...mapSettings,
        center: this.mapCenter,
      }
    },
    mapCenter () {
      return { lat: 20.1186645, lng: -98.7491321 }
    },
  },
  data() {
    return {
      mapKey: config[process.env.NODE_ENV].mapKey,
    }
  },
}
</script>
